import { supabase } from '../supabase';

export const getAziendaUsage = async (idAzienda) => {
  try {
    // 1. Dohvati sve podatke o firmi
    const { data: firma, error: firmaErr } = await supabase
      .from('aziende')
      .select('max_employees, storage_limit_gb, nome_azienda, subscription_end, plan_type')
      .eq('id', idAzienda)
      .single();

    if (firmaErr) throw firmaErr;

    // 2. Prebroji aktivne radnike
    const { count: radniciCount, error: countErr } = await supabase
      .from('profili')
      .select('*', { count: 'exact', head: true })
      .eq('id_azienda', idAzienda)
      .eq('attivo', true);

    if (countErr) throw countErr;

    // 3. Izračunaj Storage (Bajtovi u GB)
    const { data: files, error: storageErr } = await supabase
      .storage
      .from('aziende')
      .list(idAzienda.toString(), { limit: 1000 });

    if (storageErr) throw storageErr;

    const totalBytes = files?.reduce((acc, file) => acc + (file.metadata?.size || 0), 0) || 0;
    const totalGb = totalBytes / (1024 ** 3);

    // 4. Kalkulacija ugovora
    const danas = new Date();
    const krajUgovora = new Date(firma.subscription_end);
    const preostaloDana = Math.ceil((krajUgovora - danas) / (1000 * 60 * 60 * 24));

    return {
      success: true,
      data: {
        nome: firma.nome_azienda,
        plan: firma.plan_type,
        radnici: {
          koristi: radniciCount || 0,
          limit: firma.max_employees || 0,
          procenat: Math.min(((radniciCount / firma.max_employees) * 100), 100).toFixed(0)
        },
        storage: {
          koristi: totalGb.toFixed(2),
          limit: firma.storage_limit_gb || 0,
          procenat: Math.min(((totalGb / firma.storage_limit_gb) * 100), 100).toFixed(0)
        },
        ugovor: {
          kraj: firma.subscription_end,
          preostalo: preostaloDana,
          hitno: preostaloDana < 30
        }
      }
    };
  } catch (err) {
    console.error("Greška pri kalkulaciji statusa:", err.message);
    return { success: false, error: err.message };
  }
};